/* ==========================================================================
   Counter > Config
   ========================================================================== */

module.exports = {
    component: 'Counter',
    max: 9,
    min: 0,
    init: true,
    value: 0,
    enablePropagation: false,
    cssValid: 'is-valid',
    cssError: 'has-error',
    counterIncrement: 'data-counter-increment',
    counterDecrement: 'data-counter-decrement',
    type: false,
    onChange: []
};
